// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";

// Dto
import { ApplicantUserLog } from "Globals/Models/DTO/ApplicantUserLog";
import { ApplicantUserDTO } from "Globals/Models/DTO/ApplicantUserDTO";

export class ApplicantUserModel extends ModelBase<ApplicantUserModel> {
    @MobX.observable public id: string | null = "";
    @MobX.observable public firstName: string = "";
    @MobX.observable public surname: string = "";
    @MobX.observable public emailAddress: string = "";
    @MobX.observable public phoneNumber: string = "";
    @MobX.observable public applicantStatusId: string = "";
    @MobX.observable public rejectReason: string | null = "";
    @MobX.observable public logs: ApplicantUserLog[] = [];
    @MobX.observable public canStartNewApplicationForm: boolean = true;

    @MobX.action
    public fromDto = (model: ApplicantUserDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.firstName = model.firstName;
            this.surname = model.surname;
            this.emailAddress = model.emailAddress;
            this.phoneNumber = model.phoneNumber;
            this.rejectReason = model.rejectReason ? model.rejectReason : null;
            this.applicantStatusId = model.applicantStatusId;
            this.logs = model.logs;
            this.canStartNewApplicationForm = model.canStartNewApplicationForm;
        }
    };

    @MobX.action
    public toDto = (): ApplicantUserDTO => {
        let model: ApplicantUserDTO = {
            id: this.id,
            firstName: this.firstName,
            surname: this.surname,
            emailAddress: this.emailAddress,
            phoneNumber: this.phoneNumber,
            rejectReason: this.rejectReason,
            applicantStatusId: this.applicantStatusId,
            logs: this.logs,
            canStartNewApplicationForm: this.canStartNewApplicationForm,
        };
        return model;
    };
    @MobX.action
    public reset = (): void => {
        this.id = "";
        this.firstName = "";
        this.surname = "";
        this.emailAddress = "";
        this.phoneNumber = "";
        this.rejectReason = "";
        this.applicantStatusId = "";
        this.logs = [];
        this.canStartNewApplicationForm = true;
    };
}
